import type { Release } from '../releases.ts';

export default {
  version: '0.4.0',
  date: '2026-09-28',
  title: 'Automation',
  summary: [
    'A visual workflow builder with triggers, conditions, approvals, webhooks and schedules',
    'Run history and an approvals inbox',
  ],
  features: [
    'Visual workflow builder with triggers, conditions, approvals, webhooks and schedules',
    'Run history and an approvals inbox',
  ],
  fixes: [],
} satisfies Release;
